import { render, staticRenderFns } from "./libraryNumManagement.vue?vue&type=template&id=2b7cc00d&scoped=true&"
import script from "./libraryNumManagement.vue?vue&type=script&lang=js&"
export * from "./libraryNumManagement.vue?vue&type=script&lang=js&"
import style0 from "./libraryNumManagement.vue?vue&type=style&index=0&id=2b7cc00d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7cc00d",
  null
  
)

export default component.exports